import React from 'react';

function App() {
  return (
    <div className="App">
      <h1>Hello, GitHub Pages!</h1>
      <p>This React app is automatically deployed using GitHub Actions!</p>
    </div>
  );
}

export default App;
